import config from '@/env';
// 导入插件
import axios from 'axios';

export function remote_log(msg) {
    const url = `${config.apiUrl}/api/log/print/`;
    msg = JSON.stringify(msg);
    msg = `前端测试打印log: ${msg}`
    var params = {
        "log": msg
    }
    const response = axios.post(url, params);
}



// =============================================================================================>>
export function getBrowserType() {
    const ua = navigator.userAgent;

    console.log('--');
    console.log(ua);
    console.log('--');

    // 检测微信浏览器
    const isWeChat = /MicroMessenger/i.test(ua);

    // 检测各大浏览器
    const isChrome = /Chrome/i.test(ua) && !/Edg/i.test(ua);
    const isSafari = /Safari/i.test(ua) && !/Chrome/i.test(ua);
    const isFirefox = /Firefox/i.test(ua);
    const isEdge = /Edg/i.test(ua);

    let browserType = '';

    if (isWeChat) {
        browserType = 'WeChat';
    } else if (isChrome) {
        browserType = 'Chrome';
    } else if (isSafari) {
        browserType = 'Safari';
    } else if (isFirefox) {
        browserType = 'Firefox';
    } else if (isEdge) {
        browserType = 'Edge';
    } else {
        browserType = 'Unknown';
    }

    localStorage.setItem('browserType', browserType);
    return browserType
}

export function getDeviceType() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    let deviceType = "Unknown";

    if (/android/i.test(userAgent)) {
        deviceType = "Android";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        deviceType = "iOS";
    } else if (/Windows NT/.test(userAgent)) {
        deviceType = "Windows PC";
    } else if (/Macintosh/.test(userAgent)) {
        deviceType = "Mac PC";
    } else if (/Linux/.test(userAgent)) {
        deviceType = "Linux PC";
    }

    localStorage.setItem('deviceType', deviceType);
    return deviceType;
}

// 检查并获取设备信息（如有必要）
export const checkAndStoreBrowserAndDeviceType = async () => {
    const browserType = localStorage.getItem('browserType');
    const deviceType = localStorage.getItem('deviceType');
    if (!browserType) {
        getBrowserType()
    }
    if (!deviceType) {
        getDeviceType()
    }
};
// <<=============================================================================================





// // =============================================================================================>>
// // 获取客户端IP地址的函数，包含重试逻辑 (依赖外部接口来获取ip地址) 现在是用淘宝开放平台付费的云服务接口了  (0.1元试用1万次!)
//     // 涉及url: https://market.console.aliyun.com/
// export const getClientIp = async (retryCount = 20) => {
//     const url = 'https://c2ba.api.huachen.cn/ip?ip=localhost';
//     const headers = {
//         'Authorization': 'APPCODE ebcfc9bb41ba49318977c0d3c8c52aa7' // 在淘宝开放平台的云服务商那获取的APPCODE
//     };
//
//     try {
//         // 使用 await 等待 axios.get 完成
//         const response = await axios.get(url, { headers });
//         console.log(']]]]]]]]]]]]]]]]');
//         console.log(response);
//         console.log(response.data.data.ip);
//         console.log(']]]]]]]]]]]]]]]]');
//
//         const user_ip = response.data.data.ip;
//         const user_ip_country = response.data.data.country;
//         const user_ip_province = response.data.data.region;
//         const city = response.data.data.city;
//         const district = response.data.data.district;
//         const user_ip_city = city + district;
//
//         const user_ip_info = {
//             'user_ip':user_ip, 'user_ip_country':user_ip_country,
//             'user_ip_province':user_ip_province, 'user_ip_city':user_ip_city,
//         }
//
//         // 存储用户IP到本地存储
//         localStorage.setItem('user_ip', user_ip);
//         localStorage.setItem('user_ip_country', user_ip_country);
//         localStorage.setItem('user_ip_province', user_ip_province);
//         localStorage.setItem('user_ip_city', user_ip_city);
//
//         return user_ip_info;
//
//     } catch (error) {
//         console.error(`获取客户端IP地址时出错 (剩余重试次数: ${retryCount - 1}):`, error);
//         if (retryCount > 1) {
//             return await getClientIp(retryCount - 1);
//         }
//         return null;
//     }
// };
//
//
// export const log_first_visit = async (user_ip_info) => {
//     const url = `${config.apiUrl}/api/tool/log_first_visit/`;
//     const params = {
//         user_ip: user_ip_info.user_ip,
//         user_ip_country: user_ip_info.user_ip_country,
//         user_ip_province: user_ip_info.user_ip_province,
//         user_ip_city: user_ip_info.user_ip_city,
//     };
//
//     try {
//         // 添加 try-catch 错误处理
//         const response = await axios.post(url, params);
//         const success = response.data.success;
//         const msg = response.data.msg;
//         console.log(msg);
//         console.log('--------');
//     } catch (error) {
//         console.error('记录第一次访问时出错:', error);
//     }
// };
//
//
//
// // 检查并获取IP信息（每次打开页面都会执行; 在axios-interceptor.js文件中执行）
// export const checkAndStoreIpInfo = async () => {
//     console.log('!!!!```````````````````````');
//     const user_ip = localStorage.getItem('user_ip');
//     const user_ip_city = localStorage.getItem('user_ip_city');
//
//     if (!user_ip || !user_ip_city) {
//         const user_ip_info = await getClientIp();
//
//         if (user_ip_info) { // 检查 user_ip_info 是否为 null
//             await log_first_visit(user_ip_info);
//         } else {
//             console.error('无法获取用户IP信息');
//         }
//     }
// };
// // <<=============================================================================================
//








// weixin-js-sdk相关:
// =============================================================================================>>
import wx from 'weixin-js-sdk';

// 获取微信配置，并初始化微信JS-SDK
export async function getWeChatConfig() {
    try {
        const currentUrl = window.location.href.split('#')[0];
        remote_log(currentUrl)
        remote_log('-------------->>11111')

        const url = `${config.apiUrl}/api/tool/get_wechat_config/?current_url=${currentUrl}`;
        const response = await axios.get(url);
        const wechatConfig = response.data;

        wx.config({
            // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            debug: false,
            appId: wechatConfig.appId,
            timestamp: wechatConfig.timestamp,
            nonceStr: wechatConfig.nonceStr,
            signature: wechatConfig.signature,
            // jsApiList: ['checkJsApi', 'openLocation', 'getLocation', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'], // 必填
            jsApiList: ['checkJsApi', 'updateAppMessageShareData', 'updateTimelineShareData', ], // 必填
        });

        // 返回一个Promise以处理异步流程
        return new Promise((resolve, reject) => {
            // 只有核实了是在微信中打开此页面的情况下, 才会触发这里的 wx.ready()函数, 才会执行wx相关的配置
            wx.ready(() => {
                console.log('WeChat JS-SDK ready');
                resolve(wechatConfig);
            });

            wx.error((res) => {
                console.log('js-sdk的接口使用有问题:', res);
                console.error('WeChat JS-SDK error:', res);
                reject(res);
            });
        });
    } catch (error) {
        console.error('Error getting WeChat config:', error);
        remote_log('-------------->>2222')
        remote_log(error)
        throw error;
    }
}

// 仅用于检查一下我的微信公众号的js接口有没有权限 (但是返回结果都是true, 跟实际情况不符, 没啥用) [待删]
export function checkJsApiSupport(jsApiList) {
    console.log('----------->>>');
    wx.checkJsApi({
        jsApiList: jsApiList,
        success: (res) => {
            // remote_log(res)
            remote_log(res.checkResult)
        },
        fail: (err) => {
            console.error('checkJsApi failed', err);
            remote_log(JSON.stringify(err))
        },
        complete: (res) => {
            console.log('complete log1:', res);
            remote_log(`complete log1: ${JSON.stringify(res)}`)
        },
    });
}

// 初始化微信分享
export function initWeChatShare(shareTitle, shareDesc, shareLink, shareImgUrl) {
    // remote_log('22222')
    // remote_log('正在使用新接口...')
    wx.updateAppMessageShareData({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareLink, // 分享链接
        imgUrl: shareImgUrl, // 分享图标
        success: function(res) {
            // 设置成功
            console.log('分享设置成功');
            // remote_log(res)
            // remote_log('分享给朋友: 设置完成...')
        },
        fail: function(err) {
            remote_log(JSON.stringify(err))
            console.error('updateAppMessageShareData failed', err);
        },
        complete: (res) => {
            console.log('complete log3:', res);
            remote_log(`complete log3: ${JSON.stringify(res)}`)
        },
    });
    wx.updateTimelineShareData({
        title: shareTitle, // 分享标题
        link: shareLink, // 分享链接
        imgUrl: shareImgUrl, // 分享图标
        success: function(res) {
            // 设置成功
            console.log('分享设置成功');
            // remote_log(res)
            // remote_log('分享到朋友圈: 设置完成')
        },
        fail: function(err) {
            remote_log(JSON.stringify(err))
            console.error('updateTimelineShareData failed', err);
        },
        complete: (res) => {
            console.log('complete log4:', res);
            // remote_log(`complete log4: ${JSON.stringify(res)}`)
        },
    });
}


// <<=============================================================================================












export async function getIpInfo() {
    const url = 'https://c2ba.api.huachen.cn/ip?ip=localhost';
    const headers = {
        'Authorization': 'APPCODE ebcfc9bb41ba49318977c0d3c8c52aa7' // 替换为你的 APPCODE
    };

    try {
        const response = await fetch(url, { headers });

        if (!response.ok) {
            console.error(`请求失败，状态码：${response.status}`);
            return null;
        }

        const result = await response.json();
        const data = result.data || {};

        const ipCountry = data.country || '';
        const ipProvince = data.region || '';
        const ipCity = `${data.city || ''} ${data.district || ''}`.trim();
        const ipAddress = `${ipCountry} ${ipProvince} ${ipCity}`.trim();

        const ipInfo = {
            ip: data.ip || '未知',
            ip_country: ipCountry,
            ip_province: ipProvince,
            ip_city: ipCity,
            ip_address: ipAddress,
        };

        console.log(ipInfo);
        return ipInfo;
    } catch (error) {
        console.error('请求错误:', error);
        return null;
    }
}





























//
